import { createBrowserRouter } from "react-router-dom";
import Main from "../Layout/Main";
import Home from "../Sections/Home/Home/Home";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main></Main>,
    children: [
      {
        path: "/",
        element: <Home></Home>,
      },
    ],
  },
]);
export default router;
